import React, { useState, useEffect } from 'react';
import utils from 'utils';
import ResponsiveListbox from 'components/Form/ResponsiveListbox';
import { sortArrayOfObjectsByKey } from '@ehi/global-marketing-interface/lib/utils/js/array';

const CountrySelector = ({ countries, currentPageTitle }) => {
  const [countriesState, setCountriesState] = useState([]);

  useEffect(() => {
    const sortedCountries = sortArrayOfObjectsByKey(countries, 'countryTitle');
    setCountriesState(sortedCountries);
  }, []);

  const countryOptions = countriesState?.map((option) => ({ value: option.countryPath, label: option.countryTitle }));

  const handleChange = (e) => {
    if (e) {
      window.location = e;
    }
  };

  return (
    <div>
      <ResponsiveListbox
        name='select_country'
        label={utils.i18n('country_selector')}
        onChange={handleChange}
        value={location.pathname}
        options={countryOptions}
        currentPageTitle={currentPageTitle}
        countrySelector={true}
      />
    </div>
  );
};

export default CountrySelector;
